module.exports = __webpack_public_path__ + "static/media/back2.50be6c1b.svg";